import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Learnset } from '../models/learnset.model';
import { TopicStructure } from '../models/topic-structure.model';
import { Flashcard } from '../models/flashcard.model';

@Injectable({
  providedIn: 'root'
})
export class LearnsetService {

  private baseUrl = environment.baseUrl;

  constructor(private http: HttpClient) {}

  generateStructure(prompt: string, files: File[]): Observable<any> {
    const formData = new FormData();
    formData.append('prompt', prompt);
    if (files?.length > 0) {
      files.forEach(file => {
        formData.append('file', file);
      });
    }

    return this.http.post<any>(`${this.baseUrl}/learnsets/structure/generate`, formData);
  }

  generateLearnset(prompt: string, topicStructure: TopicStructure, numberOfCards: string): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/learnsets/generate`, { prompt: prompt, topicStructure: topicStructure.getFilteredTopics(), numberOfCards: numberOfCards });
  }

  addSuggestionsToLearnset(flashcards: Flashcard[]): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/flashcards/add-suggestions`, { flashcards: flashcards });
  }

  generateFromScript(pdfContents: string[], prompt: string): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/learnsets/generate/script`, { pagesContents: pdfContents, prompt });
  }

  generateFromText(textContent: string, learncardsRange: string): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/learnsets/generate/from-text`, { textContent, learncardsRange });
  }

  saveLearnset(learnset: Learnset): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/learnsets/save`, { learnset: learnset });
  }

  updateLearnset(learnset: Learnset): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/learnsets/update`, { learnset: learnset });
  }

  getLearnset(learnsetId: string): Observable<Learnset> {
    return this.http.get<Learnset>(`${this.baseUrl}/learnsets/${learnsetId}`);
  }  

  getLearnsets(): Observable<Learnset[]> {
    return this.http.get<Learnset[]>(`${this.baseUrl}/learnsets`);
  }

  getLearnsetsByCourse(courseId: number): Observable<Learnset[]> {
    return this.http.get<Learnset[]>(`${this.baseUrl}/learnsets/course/${courseId}`);
  }

  getAllWithOpenCards(): Observable<Learnset[]> {
    return this.http.get<Learnset[]>(`${this.baseUrl}/learnsets/open-cards`);
  }

  deleteLearnset(id: number) {
    return this.http.delete<Learnset>(`${this.baseUrl}/learnsets/${id}`);
  }

  getSuggestionFlashcards(learnsetId: string): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/learnsets/${learnsetId}/suggested-cards`);
  }
}
